/**
 * Posts a car booking to the Chakri Travels WhatsApp bot.
 * Falls back to opening WhatsApp with the booking details pre-filled when the
 * REACT_APP_BOOKING_API env var is not set (i.e., preview environment).
 *
 * Returns: { mode: 'api' | 'whatsapp', record?: <bot response>, error?: <message> }
 */
import { BUSINESS } from "@/data/site";

const apiBase = (process.env.REACT_APP_BOOKING_API || "").replace(/\/$/, "");
const apiKey = process.env.REACT_APP_BOOKING_API_KEY || "";

const buildWaMessage = (b) =>
  encodeURIComponent(
    `Hello Chakri Travels,
I'd like to book a car.

• Name: ${b.customerName}
• Mobile: ${b.customerPhone}
• Pickup: ${b.pickupLocation}
• Drop: ${b.dropLocation}
• Date: ${b.pickupDate}
• Time: ${b.pickupTime}
• Car: ${b.carType}
• Passengers: ${b.passengers}
${b.specialRequest ? `• Notes: ${b.specialRequest}` : ""}`
  );

export async function submitBooking(payload) {
  // 1. Try the live bot if configured
  if (apiBase) {
    try {
      const res = await fetch(`${apiBase}/book-car`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(apiKey ? { "x-api-key": apiKey } : {}),
        },
        body: JSON.stringify(payload),
      });
      const json = await res.json().catch(() => ({}));
      if (res.ok && json.success) return { mode: "api", record: json.data };
      // fall through to WhatsApp if bot is down
      console.warn("Bot rejected booking — falling back to WhatsApp deep link", json);
    } catch (e) {
      console.warn("Bot unreachable — falling back to WhatsApp deep link", e?.message);
    }
  }

  // 2. WhatsApp fallback (works everywhere, no backend needed)
  const url = `https://wa.me/91${BUSINESS.primaryWhatsApp}?text=${buildWaMessage(payload)}`;
  window.open(url, "_blank");
  return { mode: "whatsapp", record: { id: null, ...payload } };
}
